import {
  USER_TYPE_CREATE, USER_TYPE_SAVE_FAILURE, USER_TYPE_SAVE_SUCCESS
} from './mutation-types'

export default {
  state: {
    user_types: []
  },
  getters: {
    user_types: state => {
      return state.user_types
    }
  },
  actions: {
    [USER_TYPE_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/user_types', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(USER_TYPE_SAVE_FAILURE, res.data)
            } else {
              commit(USER_TYPE_SAVE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [USER_TYPE_SAVE_FAILURE] (state, data) {
      console.log('USER_TYPE_SAVE_FAILURE')
    },
    [USER_TYPE_SAVE_SUCCESS] (state, data) {
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/usertype-new.js